module.exports = __webpack_public_path__ + "img/thumbnail_Cheetah_m_albino.06ff46c3.png";